export default "__VITE_ASSET__BL84ML8I__"